// Copyright (c) 2016 Deere & Company

import './purchase-info-panel.scss';
import React, {PropTypes} from 'react';
import DealerInfo from '../../shared/components/dealer-info';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import {buildDate} from '../../../shared/services/build-date';

const PurchaseInfoPanel = props =>
    <section className='purchase-info-panel'>
        <header>
            <FormattedMessage id='PURCHASE_INFO'/>
        </header>
        <div className='order-info'>
            <LabeledString
                data={props.product.purchaserType.value}
                label='PURCHASER_TYPE'
            />
            <LabeledString
                data={props.product.endUseCode.value}
                label='END_USE_CODE'
            />
            <LabeledString
                data={props.product.operatingManualIdNumber}
                label='OPERATORS_MANUAL_NUMBER'
            />
            <LabeledString
                data={props.product.licensePlateNumber}
                label='LICENSE_PLATE_NUMBER'
            />
            <LabeledString
                data={buildDate(props.product.deliveryDate)}
                label='DELIVERED'
            />
            <LabeledString
                data={buildDate(props.product.registrationDate)}
                label='REGISTERED'
            />
            <LabeledString
                data={buildDate(props.product.expectedDateOfFirstUse)}
                label='EXPECTED_FIRST_USE'
            />
        </div>
        <DealerInfo
            dealerId={props.product.dealer.account}
            dealerName={props.product.dealer.name}
            industryIndicator={props.product.dealer.industryIndicator}
            label='RESPONSIBLE_DEALER'
            location={props.product.dealer.location}
        />
        <div className='order-info-dates'>
            <LabeledString
                data={props.product.invoiceNumber}
                label='INVOICE_NUMBER'
            />
            <LabeledString
                data={buildDate(props.product.invoiceDate)}
                label='INVOICED'
            />
            <LabeledString
                data={buildDate(props.product.settlementDate)}
                label='SETTLED'
            />
        </div>
        <DealerInfo
            dealerId={props.product.invoicedDealer.account}
            dealerName={props.product.invoicedDealer.name}
            industryIndicator={props.product.invoicedDealer.industryIndicator}
            label='INVOICE_DEALER'
            location={props.product.invoicedDealer.location}
        />
    </section>;

PurchaseInfoPanel.displayName = 'PurchaseInfoPanel';
PurchaseInfoPanel.propTypes = {
    product: PropTypes.instanceOf(Product).isRequired
};

export default PurchaseInfoPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/purchase-info-panel.js